import { render, staticRenderFns } from "./CollectionsItem.vue?vue&type=template&id=ffdc9b04&scoped=true"
import script from "./CollectionsItem.vue?vue&type=script&lang=js"
export * from "./CollectionsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdc9b04",
  null
  
)

export default component.exports